export default __webpack_public_path__ + "static/media/step-group.a385a712.svg";